import { MutationTree } from 'vuex'
import { PronosticoHidricoState, StoreError } from '@/store/modules/pronostico-hidrico/types'

export const mutations: MutationTree<PronosticoHidricoState> = {
  PRONOSTICO_HIDRICO_FETCHED (state, payload: PronosticoHidricoState) {
    state.error = { state: false }
    state.etiqueta_list = payload.etiqueta_list
    state.estacion_id = payload.estacion_id
    state.pronostico = payload.pronostico.map((data) => ({ ...data, pronostico: data.pronostico ? { ...data.pronostico, infodata: data.pronostico.infodata2 } : null }))
    state.link_descarga = payload.link_descarga
    state.isLoaded = true
  },
  PRONOSTICO_HIDRICO_ERROR (state, payload: StoreError) {
    state.error = payload
  },
  PRONOSTICO_HIDRICO_DELETED (state) {
    state.error = { state: false }
    state.etiqueta_list = []
    state.pronostico = []
  }
}
